import { LotteryConfigModel } from "../models/lottery-configuration-model";
import { Lottery } from "../../../models/lottery";

export const stastnych10Config: LotteryConfigModel = {
    lottery: Lottery.stastnych10,
    boardCount: 4,
    primaryBoardSize: 10,
    defaultStake: 10,
    defaultStakeKasa: 1000,
    primaryNumbers: 80,
    boardLabel: "Sloupec",

    addonBoardSize: 6,
    addonNumbers: 9,
    addonPrice: 10,

    primaryMinBoardSize: 1,
    stakeOptions: [...new Array(20)].map((_, i) => (i + 1) * 10),

    hasCalculatedJackpot: true,
    hasDurationComponent: true,
    hasDrawOptions: true,
    hasMultidrawNotification: true,
    hasAllOrOneMultidrawOptions: false,
    hasSubscription: true,
    isDrawnEveryDay: true,
    durationTitle: "Šťastných 10 losujeme <strong>2x denně - ve 12:00 a 20:00.</strong>",
    durationTitleShort: "Šťastných 10 losujeme 2x denně - ve 12:00 a 20:00.",
    maxDuration: 96,

    multidrawDurationOptions: [
        { value: "afternoon", valueKasa: "Midday", mainText: "Polední", hour: 12, drawName: "aft" },
        { value: "evening", valueKasa: "Evening", mainText: "Večerní", hour: 20, drawName: "evn" },
    ],
};
